import {
    StyleSheet
} from "react-native";

const stylesheet = StyleSheet.create({
    headerContainer: {
        justifyContent: "space-between",
        flexDirection: "row",
        alignItems: "center",
        flexWrap: "wrap"
    },
    tableHeaderRow: {
        justifyContent: "space-between",
        flexDirection: "row",
        alignItems: "center"
    },
    tableDataRow: {
        justifyContent: "space-between",
        flexDirection: "row",
        alignItems: "center"
    },
    emptyStateContainer: {
        justifyContent: "center",
        alignItems: "center",
        minHeight: 240
    },
    loadingContainer: {
        justifyContent: "center",
        alignItems: "center",
        minHeight: 280
    },
    statusBadge: {
        alignSelf: "flex-start"
    },
    targetBadge: {
        alignSelf: "flex-start"
    },
    actionCell: {
        alignItems: "flex-end",
        flex: 1.2
    },
    paginationContainer: {
        width: "100%"
    },
    tableContainer: {
        overflow: "hidden"
    },
    searchContainer: {
        minWidth: 260,
        flex: 1
    },
    container: {
        width: "100%",
        flex: 1
    },
    subjectCell: {
        flex: 3
    },
    targetCell: {
        flex: 1.8
    },
    statusCell: {
        flex: 1.4
    },
    dateCell: {
        flex: 1.6
    }
});
export default stylesheet;
